import React, { useState, useEffect, useRef } from "react";
import { inject, observer } from "mobx-react"; // eslint-disable-line
import axios from "axios";
import Countdown from "react-countdown";

const GCXNextSmall = (props) => {
  const timer = useRef(0);

  /// USE STATE

  const [upNext, setUpNext] = useState("loading");

  /// USE EFFECT

  useEffect(() => {
    /* Remove for production */
    const url = `${process.env.REACT_APP_LOCAL_URI}/gcx-next-small/`;
    /* Remove for production */

    let streamer = window.location.href.replace(url, "").split("/");
    if (streamer[0][0] === "@" || streamer[0][0] === "+") {
      streamer[2] = streamer[0][0];
      streamer[0] = streamer[0].substr(1, streamer[0].length);
    } else {
      streamer[2] = "@";
    }

    if (streamer[0] !== "") {
      let streamType = streamer[2],
        username = streamer[0],
        slug = streamer[1];

      /* Remove for production */
      props.gcxStore.socketConnect(streamType, username, slug);

      receive();

      timer.current = setInterval(() => receive(), 10000);

      return () => props.gcxStore.socketDisconnect();
    }
    //props.userStore.getAccessToken();
  }, []);

  /// FUNCTIONS

  const receive = () => {
    const URL = process.env.REACT_APP_GCX_SERVICE_URI + "/getGcxMarathon";

    axios
      .post(URL)
      .then((response) => {
        setUpNext(response.data[1].streamer);
      })
      .catch((err) => console.log("***** write to PG error:", err));
  };

  return (
    <div className="gcx-next-small">
      <div className="upnext">
        {upNext === "Darkness429" ||
        upNext === "Chefsteve330" ||
        upNext === "alltimebrianna" ||
        upNext === "Aztecross" ||
        upNext === "CtrlAltQuin" ||
        upNext === "Kruzadar" ||
        upNext === "BigDaddyTeej" ||
        upNext === "Leopard & Datto"
          ? "Tomorrow: "
          : "Up Next: "}{" "}
        {upNext}
      </div>
    </div>
  );
};

export default inject("gcxStore")(observer(GCXNextSmall));
